import React from "react";
import NavBar from "../components/NavBar";
import DiaryEntry from "../components/DiaryEntry";
import QuoteDisplay from "../components/QuoteDisplay";

const Diary = () => {
  return (
    <div>
      <QuoteDisplay
       apiUrl="https://official-joke-api.appspot.com/random_joke"
        className="custom-quote-card-style"
      />
      <DiaryEntry />
      <NavBar />
    </div>
  );
};

export default Diary;